import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../store/authStore';

function Header() {
  const { user, isAuthenticated, login, logout } = useAuth();

  return (
    <header className="header">
      <Link to="/" className="navbar-brand">
        Vendor Studio
      </Link>
      {isAuthenticated && (
        <nav>
          <NavLink to="/" end>
            Dashboard
          </NavLink>
          <NavLink to="/assets">Assets</NavLink>
          <NavLink to="/assets/new">New Asset</NavLink>
          <NavLink to="/sales">Sales</NavLink>
          <NavLink to="/payouts">Payouts</NavLink>
          <NavLink to="/messages">Messages</NavLink>
        </nav>
      )}
      <div className="header-right">
        {isAuthenticated && user ? (
          <>
            <span className="user-name">{user.name || user.email}</span>
            <button type="button" className="logout-btn" onClick={logout}>
              Logout
            </button>
          </>
        ) : (
          <button type="button" className="login-btn" onClick={login}>
            Login
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
